import { PricingModules, usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { getIsCloudMenuDisabled, isUserPermitted } from '../../TowerMenu/TowerMenuUtils';
import { TOWER_MENU_ITEMS, ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { Icons } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { MenuItemContainer } from '../../TowerMenu/logicalMenuItems/MenuItemContainer';

const ISPM_MAIN_TITLE = 'ISPM';
const ICON = Icons.IdentitySearch;

export const ISPMLogicalMenuItems = ({
    handleMenuItemSelection,
    userData,
    getTowerMenuHref,
    ...props
}: LogicalItemsTypes) => {
    const { pricingModulesState } = usePricingModulesState();

    const hasCloudLicense = pricingModulesState?.[PricingModules.ISPM]?.cloudEnabled ?? false;
    const hasOnPremLicense = pricingModulesState?.[PricingModules.ISPM]?.onPremEnabled ?? false;

    const hasOnPremPermission = isUserPermitted(userData, 'insights', ROLES.VIEWER.value);
    const hasCloudPermission = isUserPermitted(userData, 'cloudInsights', ROLES.VIEWER.value);

    const isISPMEnabled = hasOnPremLicense || hasCloudLicense;

    return (
        <MenuItemContainer
            {...props}
            parentId={TOWER_MENU_ITEMS.ISPM}
            mainTitle={ISPM_MAIN_TITLE}
            icon={ICON}
            userData={userData}
            showOnlyFirstItem={!isISPMEnabled}
            getTowerMenuHref={getTowerMenuHref}
            menuItems={[
                {
                    id: TOWER_MENU_ITEMS.ISPM_AD,
                    title: 'Active Directory',
                    disabled: !hasOnPremPermission
                },
                {
                    id: TOWER_MENU_ITEMS.ISPM_CLOUD,
                    title: 'Cloud',
                    disabled: getIsCloudMenuDisabled(hasCloudLicense, hasCloudPermission, hasOnPremPermission)
                }
            ]}
            handleMenuItemSelection={handleMenuItemSelection}
        />
    );
};
